import "./security.css"

const Security = () => {
    return (
        <div className="security">
            the security
        </div>
    )
}

export default Security
